import state from '@/store/modules/spec/state'
import actions from '@/store/modules/spec/actions'
import mutations from '@/store/modules/spec/mutations'
import getters from '@/store/modules/spec/getters'

export default {
  state,
  actions,
  mutations,
  getters
}
